import { useContext } from 'react'
import styled from '@emotion/styled'
import { Flex, Box, Text } from 'rebass'
//import useMediaQuery from '@material-ui/core/useMediaQuery'
import { useHistory } from 'react-router-dom'
import { DataContext } from '../../contexts/dataContext'
import IntroTimeLine from '../organisms/IntroTimeLine'
import Arrows from '../atoms/Arrows'
import { TransparentButton, BigRedButton } from '../atoms/Buttons'
import { MediaQueries as Mq } from '../../styles/settings/theme'
import { lang } from '../../utils/lang'
import { getFaNum } from '../../utils/helpers'
import { BASE_URL } from '../../utils/constants'

const IntroGraphicTitle = styled(Text)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 1.6rem;
  font-weight: 400;
  span {
    font-size: 2.2rem;
    font-weight: 700;
    color: ${(props) => props.theme.colors.red};
  }
`

const BottomBox = styled(Flex)`
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 3rem;
  width: 100%;
`

const BottomBoxText = styled(Text)`
  font-family: ${(props) => props.theme.fonts.condensed};
  font-size: 1.2rem;
  font-weight: 300;
  line-height: 1.17;
  text-align: center;
`
const NonMobileBox = styled(Box)`
  display: none;
  ${Mq.sm} {
    display: block;
    margin-left: ${(props) => (props.ui === 'fa' ? 0 : '3rem')};
    margin-right: ${(props) => (props.ui === 'fa' ? '3rem' : 0)};
  }
  ${Mq.md} {
    margin-left: ${(props) => (props.ui === 'fa' ? 0 : '5rem')};
    margin-right: ${(props) => (props.ui === 'fa' ? '5rem' : 0)};
  }
`
const IntroGraphic = () => {
  const { formattedData, years, loading, error, setIntro, ui } =
    useContext(DataContext)
  const dir = ui === 'en' ? 'ltr' : 'rtl'
  const uiLang = ui === 'fa' ? 'fa/' : ''

  const history = useHistory()
  //const matches = useMediaQuery('(min-width:900px)')
  if (loading) {
    return (
      <Flex width="60%" alignItems="center" justifyContent="center">
        <p dir={dir}>{lang[ui]['Loading']}</p>
      </Flex>
    )
  }
  if (error) {
    return (
      <Flex width="60%" alignItems="center" justifyContent="center">
        <p dir={dir}>{ui === 'en' ? error : lang[ui]['Error']}</p>
      </Flex>
    )
  }
  const numYears = years[1] - years[0] + 1

  const handleClick = () => {
    setIntro('closed')
    const currParam = new URLSearchParams(window.location.search)
    currParam.set('intro', 'closed')
    history.push(`?${currParam.toString()}`)
  }
  return (
    <NonMobileBox width={'60%'} ui={ui}>
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="space-between"
      >
        <IntroGraphicTitle dir={dir}>
          {lang[ui]['AtLeast']}
          <span>
            {' '}
            {ui === 'en'
              ? formattedData.length
              : getFaNum(formattedData.length)}{' '}
          </span>
          {lang[ui]['Quantity']}
          <span> {ui === 'en' ? numYears : getFaNum(numYears)} </span>
          {lang[ui]['Years']}
        </IntroGraphicTitle>
        <IntroTimeLine data={formattedData} years={years} ui={ui} />
        <Box my={4}>
          <BigRedButton onClick={handleClick} ui={ui}>
            <Flex dir={dir}>
              <Box>{lang[ui]['Explore']}</Box>
              <Box mt={'2px'} ml={ui === 'en' ? 3 : 0} mr={ui === 'en' ? 0 : 3}>
                <Arrows
                  color="white"
                  width="16px"
                  height="19px"
                  flip={ui === 'fa'}
                />
              </Box>
            </Flex>
          </BigRedButton>
        </Box>
        <BottomBox dir={dir}>
          <BottomBoxText mb={2}>{lang[ui]['Contribute']}</BottomBoxText>
          <TransparentButton border="true" ui={ui}>
            <a
              href={`${BASE_URL}/${uiLang}memorial/add`}
              target="_blank"
              rel="noreferrer"
            >
              <Flex>
                <Box> {lang[ui]['Add']}</Box>
                <Box
                  mt={'2px'}
                  ml={ui === 'en' ? 3 : 0}
                  mr={ui === 'en' ? 0 : 3}
                >
                  <Arrows
                    color="white"
                    width="16px"
                    height="19px"
                    flip={ui === 'fa'}
                  />
                </Box>
              </Flex>
            </a>
          </TransparentButton>
        </BottomBox>
      </Flex>
    </NonMobileBox>
  )
}

export default IntroGraphic
